import { render, staticRenderFns } from "./CbsJoin.vue?vue&type=template&id=20b0ef37&scoped=true"
import script from "./CbsJoin.vue?vue&type=script&lang=js"
export * from "./CbsJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0ef37",
  null
  
)

export default component.exports